import { fork } from 'redux-saga/effects';

import viewSettingsSagas from '../../src/modules/WallPreview/sagas/viewSettingsSagas';

function* rootSaga() {
    yield fork(viewSettingsSagas);
}

export default rootSaga;
